import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOtherMaterialReceiveList, exportOtherMaterialReceive, cancelOtherMaterialReceive } from '../api/index.js';
import { getOrganizeTree as _getOrganizeTree } from '@/api/order';
import MaterialReceiveApplyDrawer from './materialReceiveApplyDrawer.vue';
import MaterialReceiveViewDrawer from './materialReceiveViewDrawer.vue';
import MaterialReceiveRefundDrawer from './materialReceiveRefundDrawer.vue';
import personSearchMixin from '../mixins/personSearch';
export default {
  name: 'materialReceiveList',
  components: {
    MaterialReceiveApplyDrawer: MaterialReceiveApplyDrawer,
    MaterialReceiveViewDrawer: MaterialReceiveViewDrawer,
    MaterialReceiveRefundDrawer: MaterialReceiveRefundDrawer
  },
  mixins: [personSearchMixin],
  props: {
    // 领卡列表跳转过来时回填的物料申请单号
    initCode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      form: {
        code: '',
        created_by: '',
        organize_id: '',
        material_id: '',
        name: '',
        material_type: [],
        print_type: '',
        apply_time: [],
        updated_by: '',
        status: ['1'],
        page: 1,
        pagesize: 20
      },
      materialTypeList: [{
        value: '3',
        label: '卡套'
      }, {
        value: '4',
        label: '券套'
      }, {
        value: '5',
        label: '手提袋'
      }, {
        value: '6',
        label: '宣传册'
      }, {
        value: '7',
        label: '画册'
      }],
      organizeidOptions: [],
      drawerApply: false,
      drawerView: false,
      drawerMode: 'add',
      currentRowId: '',
      drawerReceiveRefund: false,
      currentAction: 'receive',
      dataList: [],
      options: [],
      pages: {
        page: 1,
        pagesize: 20,
        totalCount: 0
      }
    };
  },
  computed: {
    drawerKey: function drawerKey() {
      return "".concat(this.drawerMode, "_").concat(this.currentRowId);
    },
    drawerReceiveRefundTitle: function drawerReceiveRefundTitle() {
      return this.currentAction === 'refund' ? '其他物料退还' : '其他物料领取登记';
    }
  },
  created: function created() {
    // 跳转过来时先回填物料申请单，再查询列表
    if (this.initCode) {
      this.form.code = this.initCode;
    }
    this.getOrganizeTree();
    this.getList();
    this.searchReceiver('');
    this.searchOperator('');
  },
  methods: {
    searchReceiver: function searchReceiver(keyword) {
      var _this = this;
      return this.searchPerson(keyword, 'receiver', function () {
        return _this.form.created_by;
      });
    },
    searchOperator: function searchOperator(keyword) {
      var _this2 = this;
      return this.searchPerson(keyword, 'operator', function () {
        return _this2.form.updated_by;
      });
    },
    // 回填物料申请单并搜索（领卡列表跳转触发）
    fillSearchCode: function fillSearchCode(code) {
      this.form.code = code;
      this.form.page = 1;
      this.getList();
    },
    getList: function getList() {
      var _this3 = this;
      var params = _objectSpread({}, this.form);
      if (this.$refs.organize) {
        params.organize_id = this.$refs.organize.getCheckedNodes(false, true).map(function (res) {
          return res.value;
        });
      }
      getOtherMaterialReceiveList(params).then(function (res) {
        _this3.dataList = _this3.flattenList(res.data.list || []);
        _this3.pages = res.pages || {};
      });
    },
    flattenList: function flattenList(list) {
      var rows = [];
      (list || []).forEach(function (item) {
        var parentKey = item.id;
        var materials = Array.isArray(item.material_items) && item.material_items.length ? item.material_items : [{}];
        materials.forEach(function (m, idx) {
          rows.push(_objectSpread(_objectSpread(_objectSpread({}, item), m), {}, {
            _rowKey: "".concat(parentKey, "_").concat(m.id || '', "_").concat(m.material_id || '', "_").concat(idx),
            _parentKey: parentKey,
            _parentSize: materials.length,
            _rowIndexInParent: idx
          }));
        });
      });
      return rows;
    },
    // 领用状态颜色：1 待领取-红 / 2 已领取-蓝 / 0 已取消-灰
    statusClass: function statusClass(row) {
      var status = String(row.status);
      if (status === '1') return 'status--pending';
      if (status === '2') return 'status--received';
      if (status === '0') return 'status--cancelled';
      return '';
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column;
      var outerProps = ['id', 'code', 'created_at', 'created_user_name', 'organize_name', 'apply_date', 'remark', 'updated_user_name'];
      var isOuter = outerProps.includes(column.property) || column.label === '操作';
      if (isOuter) {
        if (row._rowIndexInParent === 0) {
          return {
            rowspan: row._parentSize,
            colspan: 1
          };
        }
        return {
          rowspan: 0,
          colspan: 0
        };
      }
      return {
        rowspan: 1,
        colspan: 1
      };
    },
    search: function search() {
      this.form.page = 1;
      this.getList();
    },
    changeReceiveTime: function changeReceiveTime(val) {
      if (val && val.length === 2) {
        this.form.start_time = val[0];
        this.form.end_time = val[1];
      } else {
        this.form.start_time = '';
        this.form.end_time = '';
      }
    },
    handleAdd: function handleAdd() {
      this.drawerApply = true;
    },
    handleView: function handleView(row) {
      this.drawerView = true;
      this.currentRowId = row.id;
    },
    handleReturnReceive: function handleReturnReceive(row, action) {
      this.currentRowId = row.id;
      this.currentAction = action;
      this.drawerReceiveRefund = true;
    },
    // 取消领用申请单
    handleCancel: function handleCancel(row) {
      var _this4 = this;
      this.$confirm("\u786E\u5B9A\u8981\u53D6\u6D88\u3010".concat(row.code, "\u3011\u9886\u7528\u7533\u8BF7\u5355\uFF1F"), '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        cancelOtherMaterialReceive({
          id: row.id
        }).then(function () {
          _this4.getList();
        });
      }).catch(function () {});
    },
    handleEmitGetList: function handleEmitGetList() {
      this.drawerApply = false;
      this.getList();
    },
    handleExport: function handleExport() {
      var _this5 = this;
      var params = _objectSpread({}, this.form);
      if (this.$refs.organize) {
        params.organize_id = this.$refs.organize.getCheckedNodes(false, true).map(function (res) {
          return res.value;
        });
      }
      exportOtherMaterialReceive(params).then(function () {
        _this5.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      });
    },
    currentChange: function currentChange(val) {
      this.form.page = val;
      this.getList();
    },
    sizeChange: function sizeChange(val) {
      this.form.pagesize = val;
      this.form.page = 1;
      this.getList();
    },
    // 组织结构
    getOrganizeTree: function getOrganizeTree() {
      var _this6 = this;
      _getOrganizeTree().then(function (res) {
        _this6.options = res.data.list;
      });
    }
  }
};